import React from "react";
import { useNavigate } from "react-router-dom";
// Components
import CustomTitle from "./CustomTitle";
import CustomImage from "./CustomImage";
import Evvy from "../assets/images/Rectangle 1.png";
//antd
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Flex, Radio, } from "antd";

// Assests
// import AuthLogo from "../assets/images/auth-logo.png";


const AuthHeader = ({ bgColor, color, logo, isMapPage = false, isSharePage, currentView , setCurrentView, companyId }) => {
  const navigate = useNavigate();


  const goBackToShipment = () => {
    navigate("/shipment");
  };

  return (
    <section className="auth-header" style={{ backgroundColor: bgColor }}>

      {/* <img src={isSharePage===true  ? Evvy : logo} alt="" /> */}
      {companyId !== undefined && companyId !== null && isSharePage===true && (
        companyId === "4400f71a-67b4-4546-bd60-50b9e92d115b" ? (
          <CustomTitle
            text="Evvy"
            color={color}
            fontSize="24px"
            lineHeight="28px"
            fontWeight="300"
            marginBottom="0px"
          />
        ) : (
          <>
            <img src={logo} alt="" />
            <CustomTitle
              text="Zoomlogi"
              color={color}
              fontSize="20px"
              lineHeight="28px"
              fontWeight="700"
              marginBottom="0px"
            />
          </>
        )
      )}

      {isSharePage===false && (
          <>
            <img src={logo} alt="" />
            <CustomTitle
              text="Zoomlogi"
              color={color}
              fontSize="20px"
              lineHeight="28px"
              fontWeight="700"
              marginBottom="0px"
            />
          </>
      )}


      {(isMapPage && !isSharePage) && (
        <ArrowLeftOutlined
          style={{ position: "absolute", left: "15px", color: "#fff" }}
          onClick={goBackToShipment}
        />
      )}

      {isMapPage && (
        <Flex className="zl-summary-detail-switch" gap={16} style={{ marginLeft: "20px", position: "absolute", right: "15px", zIndex: "9999" }}>
          <Radio.Group
            value={currentView}
            onChange={(e) => setCurrentView(e.target.value)}
          >
            <Radio.Button className="radio-btn-group"  value="summary">Summary</Radio.Button>
            <Radio.Button  className="radio-btn-group" value="detail">Detailed</Radio.Button>
          </Radio.Group>
        </Flex>
      )}
    </section>
  );
};

export default AuthHeader;
